import { createAuthClient } from "better-auth/react";

function getAuthBaseURL(): string {
  const raw = process.env.REACT_APP_API_URL || "";
  try {
    return new URL(raw, window.location.origin).origin;
  } catch {
    return window.location.origin;
  }
}

export const authClient = createAuthClient({
  baseURL: getAuthBaseURL(),
  basePath: "/api/better-auth",
});
